import { DadosAreaConstruida } from '../types/laudo-wizard.types';
import { AMOSTRAS_PADRONIZADAS } from './amostrasPadronizadas';

export const dadosAreaConstruidaMock: DadosAreaConstruida[] = AMOSTRAS_PADRONIZADAS
  .filter(amostra => amostra.tipoImovel !== 'Terreno')
  .map(amostra => ({
    identificacao: amostra.identificacao,
    tipoImovel: amostra.tipoImovel,
    areaConstruida: Number(amostra.areaPrivativa) || 0,
    cubBase: Number(amostra.cubBase) || 0,
    ajusteAcabamento: Number(amostra.ajusteAcabamento) || 1.0,
    depreciacao: 0,
    cubAjustado: 0,
    valorFinal: 0,
  }));
